import { getDefaultClient } from '@dynamic-labs-sdk/client/core';

import { addTronWalletAdaptersExtension } from '../walletAdapters/addTronWalletAdaptersExtension';

/**
 * Adds the Tron extension to the Dynamic client.
 *
 * This is a convenience function that adds support for Tron wallets.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 */
export const addTronExtension = (client = getDefaultClient()): void => {
  addTronWalletAdaptersExtension(client);
};
